<template>
  <div class="flex flex-col gap-6">
    <PriceMethods
      v-if="showPriceMethods"
      :price-method="form.priceMethod"
      :pricing-methods="pricingMethods"
      :meta-pricing-method-counter="metaPricingMethodCounter"
      :display-style="priceMethodDisplayStyle"
      @change="$emit('change', 'priceMethod', $event)"
    />

    <PriceInputs
      :value="priceInputsValues"
      :currency-sign="l10n.currencySign"
      :placeholder-max="placeholderMax"
      @input="priceInput($event)"
    />

    <PriceSliderInput
      no-margin
      theme="new-filters"
      :price-method="form.priceMethod"
      :show-labels="false"
      :value="priceSliderValues"
      @input="priceSliderHandler"
      @changed="priceChange"
    />
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import { mapState } from 'vuex';

import PriceSliderInput from '@/components/PriceSliderInput.vue';
import PriceInputs from '@/modules/public/search/components/SearchFilters/components/FiltersTabs/Price/PriceInputs.vue';
import PriceMethods from '@/modules/public/search/components/SearchFilters/components/FiltersTabs/Price/PriceMethods.vue';
import pricingMethods from '@/modules/public/search/components/SearchFilters/components/FiltersTabs/Price/pricingMethods.json';

export default {
  name: 'Price',
  components: { PriceMethods, PriceInputs, PriceSliderInput },
  props: {
    form: {
      type: Object,
      default: () => ({
        priceMethod: null,
        priceRange: [null, null],
      }),
    },
    priceMethodDisplayStyle: { // @todo TM-421 Delete after finish of the AB test experiment, we may revert to this option
      type: String,
      validator: (style) => ['buttonGroup', 'radioGroup'].includes(style),
      required: true,
    },
  },

  data() {
    return {
      pricingMethods,
    };
  },

  computed: {
    ...mapState([
      'metaPricingMethodCounter',
      'l10n',
      'trackingCity',
    ]),
    isPriceFilterDefault() {
      return this.$store.getters.isPriceFilterDefault;
    },
    priceBoundaries() {
      return this.$store.getters.currentPriceMethodBoundaries;
    },
    showPriceMethods() {
      return this.$store.getters.hasPricingMethodFilter;
    },

    priceSliderValues() {
      return this.$store.getters.priceRangeWithDefaults;
    },

    priceInputsValues() {
      if (this.isPriceFilterDefault) {
        return [null, null];
      }
      return this.form.priceRange;
    },
    placeholderMax() {
      return this.form.priceMethod === 'per_person' ? '200+' : '10000+';
    },
  },

  methods: {
    priceInput: debounce(function ({ field, value }) { // eslint-disable-line func-names
      if (!value) {
        this.priceInputUndefined({ field, value });
        return;
      }
      let range;
      if (field === 'min') {
        // Clear max if min > max
        if (value > this.form.priceRange[1]) {
          range = [value, null];
        } else {
          const min = Math.min(value, this.priceSliderValues[1]);
          range = [min, this.form.priceRange[1]];
        }
      }

      if (field === 'max') {
        // Clear min if max > min
        if (value < this.form.priceRange[0]) {
          range = [0, value];
        } else {
          const max = Math.max(value, this.priceSliderValues[0]);
          range = [this.form.priceRange[0], max];
        }
      }

      if (!!range && !isEqual(range, this.priceSliderValues)) {
        this.$emit('change', 'priceRange', range);
        this.$emit('priceChange');
      }
    }, 500),
    priceInputUndefined({ field, value }) {
      if (field === 'min') {
        this.$emit('change', 'priceRange', [value, this.form.priceRange[1]]);
      }
      if (field === 'max') {
        this.$emit('change', 'priceRange', [this.form.priceRange[0], value]);
      }
      this.$emit('priceChange');
    },
    priceSliderHandler(range) {
      if (!isEqual(range, this.priceSliderValues)) {
        this.$emit('change', 'priceRange', range);
      }
    },
    priceChange() {
      this.$emit('priceChange');
    },
  },
};
</script>
